// BusinessCard.js
import React, { useCallback, useState, useEffect, useContext } from 'react';
import { useDropzone } from 'react-dropzone';
import { useLocation } from 'react-router-dom';
import { AuthContext } from '../Components/AuthContext';
import Navbar from '../Components/Navbar';
import Products from '../Components/Products';
import Sample from '../Components/Sample';
import Subscribe from '../Components/SubscribeSection';
import FixedImageMessage from '../Components/FixedImageMessage';
import Footer from '../Components/Footer';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import { Pagination, Autoplay } from 'swiper/modules';
import { useNavigate } from 'react-router-dom';
import danger from '../Images/danger.png';
import image from '../Images/image.png';
import add from '../Images/add.png';
import arrow from '../Images/arrow-white.png';
import arrow2 from '../Images/Arrow2.png';

const ProductEdits = () => {
  const location = useLocation();
  const productId = location.state?.productId;
  const id1  = location.state?.id ;
  console.log('id1', id1);
  console.log('productId', productId);
  const navigate = useNavigate();
  const { token } = useContext(AuthContext);
  const productEditData = location.state?.product;
  const [isLoading, setIsLoading] = useState(true); // For tracking loading state

  const [selectedPaperType, setSelectedPaperType] = useState('');
  const [selectedWeight, setSelectedWeight] = useState('');
  const [selectedOrientation, setSelectedOrientation] = useState([]);
  const [selectedPrintedSides, setSelectedPrintedSides] = useState("");
  const [selectedCornerCutStyle, setSelectedCornerCutStyle] = useState('');
  const [cornerCutStyles, setCornerCutStyles] = useState([]);
  const [selectedWhiteColor, setSelectedWhiteColor] = useState(null);
  const [whiteColorOption, setWhiteColorOption] = useState([]);
  const [selectedSpotUV, setSelectedSpotUV] = useState(null);
  const [spotUVOptions, setSpotUVOptions] = useState([]);
  const [selectedQuantity, setSelectedQuantity] = useState(null);
  const [selectedDate, setSelectedDate] = useState(0);
  const [quantityPrice, setQuantityPrice] = useState([]);
  const [productData, setProductData] = useState(null);
  const [swiperInstance, setSwiperInstance] = useState(null);
  const [sizes, setSizes] = useState([]);
  const [sizeDetails, setSizeDetails] = useState([]);
  const [selectedSize, setSelectedSize] = useState('');
  const [customSize, setCustomSize] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [width, setWidth] = useState('');
  const [height, setHeight] = useState('');
  const [widthError, setWidthError] = useState('');
  const [heightError, setHeightError] = useState('');
  const [paperTypes, setPaperTypes] = useState([]);
  const [paperDetails, setPaperDetails] = useState([]);
  const [paperWeights, setPaperWeights] = useState([]);
  const [files, setFiles] = useState([]);
  const [selectedFoiling, setSelectedFoiling] = useState('');
  const [note, setNote] = useState('');
  const [foilingColors, setFoilingColors] = useState([]);
  const [availableOrientations, setAvailableOrientations] = useState([]);
  const [printedSides, setPrintedSides] = useState([]);
  const [laminations, setLaminations] = useState([]);
  const [selectedLamination, setSelectedLamination] = useState("");
  const [designRequired, setDesignRequired] = useState('no');
  const [selectedService, setSelectedService] = useState('');
  const [services, setServices] = useState([]);
  const [isProofModalOpen, setIsProofModalOpen] = useState(false);
  const [selectedProof, setSelectedProof] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [fileUploaded, setFileUploaded] = useState(false);
  const [fileName, setFileName] = useState('');
  const [selectedImage, setSelectedImage] = useState('first');
  const [uploadedImageUrl, setUploadedImageUrl] = useState('');
  const [uploadedImageUrl2, setUploadedImageUrl2] = useState('');
  const [vatRate, setVatRate] = useState('');
  const [customWidth, setCustomWidth] = useState(null);
  const [customHeight, setCustomHeight] = useState(null);
  const [errors, setErrors] = useState({
    size: '',
    paperType: '',
    paperWeight: '',
    quantity: '',
    service: '',
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  

  useEffect(() => {
    if (productEditData) {
      setSelectedPaperType(productEditData.old_product_data.paper_type);
      setSizes(productEditData.sizes); // Set sizes from product data
    }
  }, [productEditData]);

  const getSizeDimensions = (size) => {
    console.log("Getting size dimensions for:", size);
    if (size === customSize) {
      console.log("Custom size dimensions (customWidth x customHeight):", { customWidth, customHeight });
      return {
        outerWidth: customWidth || 0, // Use customWidth state
        outerHeight: customHeight || 0, // Use customHeight state
      };
    }

    const foundSize = sizeDetails.find(detail => detail.name === size);
    if (foundSize) {
      console.log("Found preset size dimensions (width x height):", { width: foundSize.width, height: foundSize.length });
      return {
        outerWidth: foundSize.width,
        outerHeight: foundSize.length,
      };
    }
    console.log("No matching size found. Returning default 0mm dimensions.");
    return { outerWidth: 0, outerHeight: 0 };
  };

  useEffect(() => {
    if (selectedSize) {
      const { outerWidth, outerHeight } = getSizeDimensions(selectedSize);
      console.log("Effect triggered: selectedSize or customSize changed.");
      console.log("Current selectedSize:", selectedSize);
      console.log("Calculated Dimensions (outerWidth x outerHeight):", { outerWidth, outerHeight });
    }
  }, [selectedSize, customWidth, customHeight]);

  const mmToPx = (mm) => `${mm * 3.78}px`;
  const { outerWidth, outerHeight } = getSizeDimensions(selectedSize);
  console.log("Parsed Dimensions:", { outerWidth, outerHeight });

  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      const file1 = acceptedFiles[0]; // First image
      const file2 = acceptedFiles[1]; // Second image (if exists)

      const imageUrl1 = URL.createObjectURL(file1);
      setUploadedImageUrl(imageUrl1);

      if (selectedPrintedSides === 'Two Sides' && file2) {
        const imageUrl2 = URL.createObjectURL(file2);
        setUploadedImageUrl2(imageUrl2);
      } else {
        setUploadedImageUrl2(''); // Clear the second image if not "Two Sides"
      }

      setFileName(file1.name + (file2 ? `, ${file2.name}` : ''));
      setFileUploaded(true);
    }
  }, [selectedPrintedSides]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: selectedPrintedSides === 'Two Sides', // Allow multiple files only for "Two Sides"
    accept: 'image/*',
  });

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const getSizeClasses = (option) => {
    if (option === 'portrait') return 'h-20 w-12';
    if (option === 'landscape') return 'h-12 w-28';
    if (option === 'square') return 'h-16 w-16';
  };

 
    const fetchProductData = async () => {
      try {
        const response = await fetch(`https://backend.printtrio.co.uk/api/cart/view-edit-item/${id1}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            productId: productId,
            custom_size: 0,
          }),
        });

        const data = await response.json();
        setSizeDetails(data.data.size_detail);
        setProductData(data.data.product);
        setSizes(data.data.sizes);
        setPaperTypes(data.data.paper_type);
        setPaperDetails(data.data.paper_detail);
        setPaperWeights(data.data.paper_weight);
        setFiles(data.data.product.files);
        setFoilingColors(data.data.foiling_color || []);
        setNote(data.data.product.note || 'No additional notes available.');
        setAvailableOrientations(data.data.orientation || []);
        setPrintedSides(data.data.printed_side);
        setLaminations(data.data.lamination);
        setCornerCutStyles(data.data.corner_cut_style || []);
        setWhiteColorOption(data.data.white_color);
        setSpotUVOptions(data.data.spot_UV);
        setQuantityPrice(data.data.quantity_price || []);
        const vatString = data.data.vat;
        const vatValue = parseFloat(vatString);

        setVatRate(!isNaN(vatValue) ? vatValue : 0);

        if (data.data.quantity_price.length > 0) {
          setSelectedQuantity(data.data.quantity_price[0]?.quantity);
          setSelectedDate(0); // Default to first available date (index 0)
        }
      } catch (error) {
        console.error('Error fetching product:', error);
      }
    };
    useEffect(() => {
        if (id1 && productId) {
          fetchProductData();
        }
      }, [id1, productId]);
      

  const handleSizeSelect = async (newSize) => {
    setUploadedImageUrl('');
    setUploadedImageUrl2('');
    setFileUploaded(false);
    setFileName('');

    setSelectedSize(newSize);
    fetchUpdatedProductData(newSize, selectedPaperType, selectedWeight);
    if (newSize === "Custom Size") {
      setCustomSize('');
      setIsModalOpen(true);
      return;
    }

    setSelectedSize(newSize);

    try {
      const response = await fetch('https://backend.printtrio.co.uk/api/product/single-product', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          productId: productId,
          size: newSize,
          custom_size: 0
        }),
      });

      const data = await response.json();
      setProductData(data.data.product);
      setSizes(data.data.sizes);
      setPaperTypes(data.data.paper_type);
      setPaperDetails(data.data.paper_detail);
      setPaperWeights(data.data.paper_weight);
      setFoilingColors(data.data.foiling_color);
      setAvailableOrientations(data.data.orientation || []);
      setPrintedSides(data.data.printed_side);
      setLaminations(data.data.lamination);
      setCornerCutStyles(data.data.corner_cut_style || []);
      setWhiteColorOption(data.data.white_color);
      setSpotUVOptions(data.data.spot_UV);
      setQuantityPrice(data.data.quantity_price || []);
      const vatString = data.data.vat;
      const vatValue = parseFloat(vatString);
      setVatRate(!isNaN(vatValue) ? vatValue : 0);
      if (data.data.quantity_price.length > 0) {
        setSelectedQuantity(data.data.quantity_price[0]?.quantity);
        setSelectedDate(0);
      }
    } catch (error) {
      console.error('Error fetching product with selected size:', error);
    }
  };

  const handlePaperTypeSelect = async (newPaperType) => {
    setSelectedPaperType(newPaperType);
    fetchUpdatedProductData(selectedSize, newPaperType, selectedWeight);

    try {
      const response = await fetch('https://backend.printtrio.co.uk/api/product/single-product', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          productId: productId,
          paper_type: newPaperType,
          custom_size: 0,
        }),
      });

      const data = await response.json();
      setProductData(data.data.product);
      setPaperTypes(data.data.paper_type);
      setPaperDetails(data.data.paper_detail);
      setPaperWeights(data.data.paper_weight);
      setFoilingColors(data.data.foiling_color);
      setAvailableOrientations(data.data.orientation || []);
      setPrintedSides(data.data.printed_side);
      setLaminations(data.data.lamination);
      setCornerCutStyles(data.data.corner_cut_style || []);
      setWhiteColorOption(data.data.white_color);
      setSpotUVOptions(data.data.spot_UV);
      setQuantityPrice(data.data.quantity_price || []);
      const vatString = data.data.vat;
      const vatValue = parseFloat(vatString);
      setVatRate(!isNaN(vatValue) ? vatValue : 0);
      if (data.data.quantity_price.length > 0) {
        setSelectedQuantity(data.data.quantity_price[0]?.quantity);
        setSelectedDate(0);
      }
    } catch (error) {
      console.error('Error fetching product with selected paper type:', error);
    }
  };

  const handlePaperWeightSelect = async (newWeight) => {
    setSelectedWeight(newWeight);
    fetchUpdatedProductData(selectedSize, selectedPaperType, newWeight);

    try {
      const response = await fetch('https://backend.printtrio.co.uk/api/product/single-product', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          productId: productId,
          paper_weight: newWeight,
          custom_size: 0,
        }),
      });

      const data = await response.json();
      setProductData(data.data.product);
      setSizes(data.data.sizes);
      setPaperTypes(data.data.paper_type);
      setPaperDetails(data.data.paper_detail);
      setPaperWeights(data.data.paper_weight);
      setFoilingColors(data.data.foiling_color);
      setAvailableOrientations(data.data.orientation || []);
      setPrintedSides(data.data.printed_side);
      setLaminations(data.data.lamination);
      setCornerCutStyles(data.data.corner_cut_style || []);
      setWhiteColorOption(data.data.white_color);
      setSpotUVOptions(data.data.spot_UV);
      setQuantityPrice(data.data.quantity_price || []);
      const vatString = data.data.vat;
      const vatValue = parseFloat(vatString);
      setVatRate(!isNaN(vatValue) ? vatValue : 0);
      if (data.data.quantity_price.length > 0) {
        setSelectedQuantity(data.data.quantity_price[0]?.quantity);
        setSelectedDate(0);
      }
    } catch (error) {
      console.error('Error fetching product with selected paper weight:', error);
    }
  };

  const fetchUpdatedProductData = async (newSize, newPaperType, newWeight) => {
    try {
      const response = await fetch('https://backend.printtrio.co.uk/api/product/single-product', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          productId: productId,
          size: newSize || selectedSize,
          paper_type: newPaperType || selectedPaperType,
          paper_weight: newWeight || selectedWeight,
          custom_size: customSize ? 1 : 0,
        }),
      });

      const data = await response.json();
      setProductData(data.data.product);
      setQuantityPrice(data.data.quantity_price || []);
    } catch (error) {
      console.error('Error fetching product data:', error);
    }
  };

  const handleFoilingColorSelect = async (newFoilingColor) => {
    setSelectedFoiling(newFoilingColor);
    try {
      const response = await fetch('https://backend.printtrio.co.uk/api/product/single-product', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          productId: productId,
          foiling_color: newFoilingColor,
          custom_size: 0,
        }),
      });

      const data = await response.json();
      setProductData(data.data.product);
      setFoilingColors(data.data.foiling_color);
      setAvailableOrientations(data.data.orientation || []);
      setPrintedSides(data.data.printed_side);
      setLaminations(data.data.lamination);
      setCornerCutStyles(data.data.corner_cut_style || []);
      setWhiteColorOption(data.data.white_color);
      setSpotUVOptions(data.data.spot_UV);
    } catch (error) {
      console.error('Error fetching product with selected foiling color:', error);
    }
  };

  const handleOrientationSelect = async (newOrientation) => {
    setSelectedOrientation(newOrientation);

    try {
      const response = await fetch('https://backend.printtrio.co.uk/api/product/single-product', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          productId: productId,
          orientation: newOrientation,
          custom_size: 0,
        }),
      });

      const data = await response.json();
      setProductData(data.data.product);
      setAvailableOrientations(data.data.orientation || []);
      setPrintedSides(data.data.printed_side);
      setLaminations(data.data.lamination);
      setCornerCutStyles(data.data.corner_cut_style || []);
      setWhiteColorOption(data.data.white_color);
      setSpotUVOptions(data.data.spot_UV);
    } catch (error) {
      console.error('Error fetching product with selected orientation:', error);
    }
  };

  const handlePrintedSidesSelect = async (newPrintedSide) => {
    setUploadedImageUrl('');
    setUploadedImageUrl2('');
    setFileUploaded(false);
    setFileName('');
    setSelectedImage('first');
    setSelectedPrintedSides(newPrintedSide);
    if (newPrintedSide === 'One Side') {
      setUploadedImageUrl2('');
    }

    try {
      const response = await fetch('https://backend.printtrio.co.uk/api/product/single-product', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          productId: productId,
          printed_side: newPrintedSide,
          custom_size: 0
        }),
      });

      const data = await response.json();
      setProductData(data.data.product);
    } catch (error) {
      console.error('Error fetching product with selected printed side:', error);
    }
  };

  const handleLaminationSelect = async (newLamination) => {
    setSelectedLamination(newLamination);

    try {
      const response = await fetch('https://backend.printtrio.co.uk/api/product/single-product', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          productId: productId,
          lamination: newLamination,
          custom_size: 0,
        }),
      });

      const data = await response.json();
      setProductData(data.data.product);
      setFoilingColors(data.data.foiling_color);
      setAvailableOrientations(data.data.orientation || []);
      setPrintedSides(data.data.printed_side);
      setLaminations(data.data.lamination);
      setCornerCutStyles(data.data.corner_cut_style || []);
      setWhiteColorOption(data.data.white_color);
      setSpotUVOptions(data.data.spot_UV);
    } catch (error) {
      console.error('Error fetching product with selected lamination:', error);
    }
  };

  const handleCornerCutStyleSelect = async (newCornerCutStyle) => {
    setSelectedCornerCutStyle(newCornerCutStyle);

    try {
      const response = await fetch('https://backend.printtrio.co.uk/api/product/single-product', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          productId: productId,
          corner_cut_style: newCornerCutStyle,
          custom_size: 0,
        }),
      });

      const data = await response.json();
      setProductData(data.data.product);
      setFoilingColors(data.data.foiling_color);
      setAvailableOrientations(data.data.orientation || []);
      setPrintedSides(data.data.printed_side);
      setLaminations(data.data.lamination);
      setWhiteColorOption(data.data.white_color);
      setSpotUVOptions(data.data.spot_UV);
    } catch (error) {
      console.error('Error fetching product with selected corner cut style:', error);
    }
  };

  const handleWhiteColorSelect = async (newWhiteColor) => {
    setSelectedWhiteColor(newWhiteColor);

    try {
      const response = await fetch('https://backend.printtrio.co.uk/api/product/single-product', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          productId: productId,
          white_color: newWhiteColor === 'With white color' ? 1 : 0,
          custom_size: 0
        }),
      });

      const data = await response.json();
      setProductData(data.data.product);
      setFoilingColors(data.data.foiling_color);
      setAvailableOrientations(data.data.orientation || []);
      setPrintedSides(data.data.printed_side);
      setLaminations(data.data.lamination);
      setCornerCutStyles(data.data.corner_cut_style || []);
      setWhiteColorOption(data.data.white_color);
      setSpotUVOptions(data.data.spot_UV);
    } catch (error) {
      console.error('Error fetching product with selected white color:', error);
    }
  };

  const handleSpotUVSelect = async (newSpotUV) => {
    setSelectedSpotUV(newSpotUV);

    try {
      const response = await fetch('https://backend.printtrio.co.uk/api/product/single-product', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          productId: productId,
          spot_UV: newSpotUV === 'Yes' ? 1 : 0,
          custom_size: 0,
        }),
      });

      const data = await response.json();
      setProductData(data.data.product);
      setFoilingColors(data.data.foiling_color);
      setAvailableOrientations(data.data.orientation || []);
      setPrintedSides(data.data.printed_side);
      setLaminations(data.data.lamination);
      setCornerCutStyles(data.data.corner_cut_style || []);
      setWhiteColorOption(data.data.white_color);
      setSpotUVOptions(data.data.spot_UV);
    } catch (error) {
      console.error('Error fetching product with selected Spot UV:', error);
    }
  };

  const handleQuantitySelect = (quantity) => {
    setSelectedQuantity(quantity);
  };

  const handleDateSelect = (dateIndex) => {
    setSelectedDate(dateIndex);
  };

  const handleAddCustomSize = () => {
    console.log("Attempting to add custom size:", { width, height });

    if (
      width &&
      height &&
      !widthError &&
      !heightError &&
      width >= productData.min_width &&
      width <= productData.max_width &&
      height >= productData.min_length &&
      height <= productData.max_length
    ) {
      const newSize = `${width} × ${height} mm`;

      console.log("Adding new custom size:", newSize);

      setSizes([...sizes, newSize]);
      setCustomSize(newSize);
      setSelectedSize(newSize);
      setCustomWidth(parseFloat(width));
      setCustomHeight(parseFloat(height));
      setIsModalOpen(false);
      setWidth('');
      setHeight('');
    } else {
      console.log("Custom size validation failed:", { width, height, widthError, heightError });
    }
  };

  const handleModalCancel = () => {
    setIsModalOpen(false);
    setCustomSize('');
    setSelectedSize(sizes[0]);
  };

  const selectedPaperDetail = paperDetails.find(
    (detail) => detail.name === selectedPaperType
  );

  const handleDesignRequiredChange = (event) => {
    setDesignRequired(event.target.value);
    if (event.target.value === 'no') {
      setSelectedService('');
    }
  };

  const handleServiceChange = (event) => {
    setSelectedService(event.target.value);
  };

  const selectedItem = quantityPrice.find(item => item.quantity === selectedQuantity);
  const basePrice = selectedItem ? parseFloat(selectedItem[`price${selectedDate + 1}`]) : 0;
  const selectedServiceObject = services.find(service => service.name === selectedService);
  const selectedServicePrice = selectedServiceObject ? parseFloat(selectedServiceObject.price) : 0;
  const selectedPrice = basePrice + selectedServicePrice;
  const vatAmount = selectedPrice * vatRate;
  const totalPriceWithVat = selectedPrice + vatAmount;
  const pricePerItem = selectedQuantity && totalPriceWithVat
    ? (totalPriceWithVat / selectedQuantity).toFixed(2)
    : '0.00';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleClick = async () => {
    const newErrors = {
      size: '',
      paperType: '',
      paperWeight: '',
      quantity: '',
      service: '',
    };

    if (!selectedSize) {
      newErrors.size = 'Please select a size.';
    }
    if (!selectedPaperType) {
      newErrors.paperType = 'Please select a paper type.';
    }
    if (!selectedWeight) {
      newErrors.paperWeight = 'Please select a paper weight.';
    }
    if (!selectedQuantity) {
      newErrors.quantity = 'Please select a quantity.';
    }
    if (!selectedServiceObject) {
      newErrors.service = 'Please select a service.';
    }

    if (newErrors.size || newErrors.paperType || newErrors.paperWeight || newErrors.quantity || newErrors.service) {
      setErrors(newErrors);
      return;
    }

    setErrors({
      size: '',
      paperType: '',
      paperWeight: '',
      quantity: '',
    });

    const formData = new FormData();
    formData.append('product_id', productId);
    formData.append('custom_size', customSize ? 1 : 0);
    formData.append('custom_width', customWidth || '');
    formData.append('custom_length', customHeight || '');
    formData.append('size', selectedSize);
    formData.append('paper_type', selectedPaperType);
    formData.append('paper_weight', selectedWeight);
    formData.append('printed_side', selectedPrintedSides === 'One Side' ? 'one' : 'two');
    formData.append('orientation', selectedOrientation);
    formData.append('corner_cut_style', selectedCornerCutStyle);
    formData.append('lamination', selectedLamination);
    formData.append('white_color', selectedWhiteColor === 'With white color' ? 1 : 0);
    formData.append('spot_UV', selectedSpotUV === 'Yes' ? 1 : 0);
    formData.append('foiling_color', selectedFoiling);
    formData.append('quantity', selectedQuantity);
    formData.append('number_of_sheet', selectedQuantity);
    formData.append('product_price', basePrice.toFixed(2));
    formData.append('total_price', totalPriceWithVat.toFixed(2));
    formData.append('service_id', selectedServiceObject?.id || '');
    formData.append('service_description', selectedServiceObject?.description || '');

    const selectedDeliveryDate = quantityPrice[selectedDate]?.[`date${selectedDate + 1}`];
    if (!selectedDeliveryDate) {
      console.error('Delivery date is required but not selected.');
      return;
    }
    formData.append('deliver_date', selectedDeliveryDate);

    if (uploadedImageUrl) {
      const blob1 = await fetch(uploadedImageUrl).then(res => res.blob());
      formData.append('file1', blob1, 'file1.png');
    }
    if (uploadedImageUrl2) {
      const blob2 = await fetch(uploadedImageUrl2).then(res => res.blob());
      formData.append('file2', blob2, 'file2.png');
    }

    try {
      const response = await fetch('https://backend.printtrio.co.uk/api/cart/add-to-cart', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const result = await response.json();

      if (response.ok && result.success) {
        navigate('/Cart', { state: { message: 'Product added to cart successfully' } });
      } else {
        console.error('Failed to add product:', result.errors);
        console.error('Full response:', result);
      }
    } catch (error) {
      console.error('Error adding product to cart:', error);
    }
  };

  return (
    <>
      <Navbar />

      <div className="p-4 lg:mx-20 mt-10 mb-10 bg-gray-100 min-h-screen">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:m-10 min-h-screen">
          <div className="p-4 lg:p-8 sticky top-0 self-start z-10">
            <div className="mb-8 w-full ">
              {productData && productData.images && productData.images.length > 0 ? (
                <Swiper
                  modules={[Pagination, Autoplay]}
                  pagination={{ clickable: true }}
                  spaceBetween={30}
                  slidesPerView={1}
                  autoplay={{ delay: 4000, disableOnInteraction: false }}
                  loop={productData.images.length > 1}
                  speed={2000}
                  className="rounded shadow-lg"
                  onSwiper={(swiper) => setSwiperInstance(swiper)}
                  onSlideChange={() => {
                    const videos = document.querySelectorAll('video');
                    videos.forEach(video => video.pause());
                  }}
                >
                  {productData.images.map((media, index) => (
                    <SwiperSlide key={index}>
                      <div
                        className={`w-full ${productData.images.length === 1 ? 'h-80' : 'h-40 lg:h-80'}`}
                      >
                        {media.image.endsWith('.mp4') || media.image.endsWith('.webm') ? (
                          <video
                            controls
                            className="w-full h-full object-contain rounded shadow-lg"
                            onPlay={() => {
                              if (swiperInstance) swiperInstance.autoplay.stop();
                            }}
                            onEnded={() => {
                              if (swiperInstance) swiperInstance.autoplay.start();
                            }}
                            onPause={() => {
                              if (swiperInstance) swiperInstance.autoplay.start();
                            }}
                            style={{
                              width: '100%',
                              height: '100%',
                            }}
                          >
                            <source src={media.image} type="video/mp4" />
                            Your browser does not support the video tag.
                          </video>
                        ) : (
                          <img
                            src={media.image}
                            alt={`Product Media ${index + 1}`}
                            className="w-full h-full object-contain rounded shadow-lg"
                            style={{
                              width: '100%', // Set width to 100%
                              height: '100%', // Set height to 100%
                   
                            }}
                          />
                        )}
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              ) : (
                <img
                  src="https://via.placeholder.com/500"
                  alt="Placeholder"
                  className="rounded shadow-lg w-full lg:w-3/4"
                />
              )}
              <div className="p-6 bg-white rounded shadow mb-8 border-2 w-full mt-10" style={{ borderColor: '#EC008C' }}>
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-lg lg:text-xl font-bold">Product Summary</h2>
                </div>
                {selectedQuantity && selectedDate !== null && selectedItem ? (
                  <div className="flex justify-between items-center mb-4 font-bold text-lg">
                    <span>Subtotal</span>
                    <span>£{selectedPrice.toFixed(2)}</span>
                  </div>
                ) : (
                  <div className="flex justify-between items-center mb-4 font-bold text-lg">
                    <span>Subtotal</span>
                    <span>£0.00</span>
                  </div>
                )}
                <div className="flex justify-between items-center mb-4">
                  <span>VAT</span>
                  <span>£{vatAmount.toFixed(2)}</span>
                </div>
                {selectedQuantity && selectedDate !== null && selectedItem ? (
                  <div className="flex justify-between items-center mb-4 font-bold text-lg">
                    <span>Total (Inc VAT)</span>
                    <span>£{totalPriceWithVat.toFixed(2)}</span>
                  </div>
                ) : (
                  <div className="flex justify-between items-center mb-4 font-bold text-lg">
                    <span>Total (Inc VAT)</span>
                    <span>£0.00</span>
                  </div>
                )}
                <div className="flex justify-between items-center mt-6">
                  <button
                    className="flex items-center text-white px-4 py-2 rounded-full gap-3"
                    style={{ backgroundColor: '#EC008C' }}
                    onClick={handleClick}
                  >
                    Add To Cart <img src={arrow} alt="image" className="w-4 h-4" />
                  </button>
                </div>
                <div className="mt-4">
                  {errors.size && <p className="text-red-500 text-sm">{errors.size}</p>}
                  {errors.paperType && <p className="text-red-500 text-sm">{errors.paperType}</p>}
                  {errors.paperWeight && <p className="text-red-500 text-sm">{errors.paperWeight}</p>}
                  {errors.quantity && <p className="text-red-500 text-sm">{errors.quantity}</p>}
                  {errors.service && <p className="text-red-500 text-sm">{errors.service}</p>}
                </div>
              </div>
              <div className="border border-dashed border-red-500 p-4 mt-10 text-gray-600 rounded-md">
                <div className="flex items-start">
                  <img src={danger} alt="PDF" className="w-5 h-5 mr-2 mt-1.5" />
                  <p>
                    <span className="font-bold">Note:</span> {note}
                  </p>
                </div>
              </div>
            </div>
            <div className="mb-8 w-full ">
              <h1 className="text-lg lg:text-xl font-bold mb-2">Choose Your Preferred File Format</h1>
              <h2 className="text-gray-600 mb-4">Create Your Unique Design</h2>
              <p className="text-gray-600 mb-4">Download the preferred template format and unleash your creativity to design a unique and valid artwork!</p>
              <div className="flex space-x-4 mb-4">
                {productData?.files?.map((file) => (
                  <a key={file.id} href={file.file} target="_blank" rel="noopener noreferrer">
                    <img src={file.type.icon} alt={file.type.name} className="w-8 h-8" />
                  </a>
                ))}
              </div>
            </div>
          </div>
          <div className="p-4 lg:p-8 sticky top-0 self-start z-10 min-h-screen">
            <div className="flex flex-row justify-between items-center">
              <h2 className="text-lg lg:text-xl font-bold mb-2">{productData ? productData.name : 'Loading...'}</h2>
              <div className="flex justify-end mt-4">
                <button
                  className="bg-gray-300 text-gray-700 px-4 py-2 rounded-lg"
                  onClick={() => {
                    setSelectedSize('');
                    setCustomSize('');
                    setSelectedSpotUV(null);
                    setSelectedWhiteColor(null);
                    setSelectedCornerCutStyle('');
                    setSelectedLamination('');
                    setSelectedPrintedSides('');
                    setSelectedOrientation('');
                    setSelectedFoiling('');
                    setSelectedWeight(null);
                    setSelectedPaperType('');
                    fetchProductData();
                  }}
                >
                  Clear
                </button>
              </div>
            </div>
            <p className="text-gray-600 mb-4">{productData ? productData.description : 'Loading...'}</p>
            <div className="mb-4">
              <label className="block text-gray-700 font-bold mb-2">Size (mm)</label>
              <div className="flex items-center border-2 border-pink-500 rounded-xl">
                <div className="flex-1 relative">
                  <select
                    className="block w-full appearance-none text-pink-500 bg-transparent border-none focus:outline-none p-2 pr-8"
                    value={selectedSize || customSize || "Select Size"}
                    onChange={(e) => {
                      const newSize = e.target.value;
                      if (newSize === "Custom Size") {
                        setCustomSize('');
                        setIsModalOpen(true);
                      } else {
                        setCustomSize('');
                        setSelectedSize(newSize);
                        handleSizeSelect(newSize);
                      }
                    }}
                  >
                    <option value="Select Size" disabled>Select Size</option>
                    {sizes.map((size, index) => (
                      <option key={index} value={size}>{size}</option>
                    ))}
                    {productData && productData.custom_size === 1 && (
                      <option value="Custom Size">Custom Size</option>
                    )}
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-pink-500">
                    <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                      <path d="M7 10l5 5 5-5z" />
                    </svg>
                  </div>
                </div>
              </div>
              {isModalOpen && (
                <div className="fixed inset-0 z-50 bg-gray-600 bg-opacity-50 flex items-center justify-center ">
                  <div className="bg-white p-5 rounded-lg shadow-lg sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/4 max-w-xl">
                    <h2 className="text-lg font-bold mb-4">Enter Custom Size</h2>
                    <div className="mb-2">
                      <label className="block text-gray-700">Width (mm)</label>
                      <input
                        type="number"
                        value={width}
                        min={productData.min_width}
                        max={productData.max_width}
                        onChange={(e) => {
                          const newWidth = e.target.value;
                          setWidth(newWidth);
                          if (newWidth < productData.min_width || newWidth > productData.max_width) {
                            setWidthError(`Width must be between ${productData.min_width}mm and ${productData.max_width}mm`);
                          } else {
                            setWidthError('');
                          }
                        }}
                        className={`border-2 ${widthError ? 'border-red-500' : 'border-gray-300'} p-2 rounded-lg w-full`}
                        placeholder={`Enter width (${productData.min_width}-${productData.max_width}mm)`}
                      />
                      {widthError && <p className="text-red-500 mt-1">{widthError}</p>}
                    </div>
                    <div className="mb-4">
                      <label className="block text-gray-700">Height (mm)</label>
                      <input
                        type="number"
                        value={height}
                        min={productData.min_length}
                        max={productData.max_length}
                        onChange={(e) => {
                          const newHeight = e.target.value;
                          setHeight(newHeight);
                          if (newHeight < productData.min_length || newHeight > productData.max_length) {
                            setHeightError(`Height must be between ${productData.min_length}mm and ${productData.max_length}mm`);
                          } else {
                            setHeightError('');
                          }
                        }}
                        className={`border-2 ${heightError ? 'border-red-500' : 'border-gray-300'} p-2 rounded-lg w-full`}
                        placeholder={`Enter height (${productData.min_length}-${productData.max_length}mm)`}
                      />
                      {heightError && <p className="text-red-500 mt-1">{heightError}</p>}
                    </div>
                    <div className="flex justify-between">
                      <button
                        className="bg-pink-500 text-white px-4 py-2 rounded-lg"
                        onClick={handleAddCustomSize}
                        disabled={
                          !width || !height ||
                          width < productData.min_width || width > productData.max_width ||
                          height < productData.min_length || height > productData.max_length
                        }
                      >
                        Add Size
                      </button>
                      <button
                        className="bg-gray-300 text-gray-700 px-4 py-2 rounded-lg"
                        onClick={handleModalCancel}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="mt-8 mb-8">
              <label className="block text-gray-700 font-bold mb-6">Paper Type</label>
              <div className="flex flex-col lg:flex-row">
                <div className="flex flex-col lg:w-1/3">
                  {paperTypes.map((type) => (
                    <button
                      key={type}
                      className={`border p-2 mb-4 rounded-xl ${selectedPaperType === type ? 'border-pink-500 text-pink-500' : 'border-gray-300 text-gray-700'}`}
                      onClick={() => handlePaperTypeSelect(type)}
                    >
                      {type}
                    </button>
                  ))}
                </div>
                <div className="flex-1 lg:ml-5">
                  <div className="flex justify-center items-center bg-gray-200 w-full lg:w-3/4 h-40 lg:h-1/2 rounded-xl mb-8 mx-auto">
                    {selectedPaperDetail ? (
                      <img
                        src={selectedPaperDetail.image}
                        alt={selectedPaperDetail.name}
                        className="h-full object-contain rounded-xl"
                      />
                    ) : (
                      <p>No image available</p>
                    )}
                  </div>
                  <h3 className="font-bold">{selectedPaperType}</h3>
                  <p className="text-gray-500 mb-2">
                    {selectedPaperDetail ? selectedPaperDetail.description : 'No description available.'}
                  </p>
                  <label className="block text-gray-700 font-bold mb-2">Choose your weight (GSM)</label>
                  <div className="flex">
                    {paperWeights.map((weight) => (
                      <button
                        key={weight}
                        className={`border p-2 rounded ${selectedWeight === weight ? 'border-pink-500 text-pink-500' : 'border-gray-300 text-gray-700'} mx-1`}
                        onClick={() => handlePaperWeightSelect(weight)}
                      >
                        {weight}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 font-bold mb-2">Foiling color</label>
              <div className="flex items-center border-2 border-pink-500 rounded-xl">
                <div className="flex-1 relative">
                  <select
                    className="block w-full appearance-none text-pink-500 bg-transparent border-none focus:outline-none p-2 pr-8"
                    value={selectedFoiling}
                    onChange={(e) => handleFoilingColorSelect(e.target.value)}
                  >
                    <option value="">Select Foiling Color</option>
                    {foilingColors.map((color, index) => (
                      <option key={index} value={color}>
                        {color}
                      </option>
                    ))}
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-pink-500">
                    <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                      <path d="M7 10l5 5 5-5z" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-8 mb-8">
              {availableOrientations.length > 0 && (
                <div className="mb-4">
                  <label className="block text-gray-700 font-bold mb-4">Orientation</label>
                  <div className="flex flex-col lg:flex-row gap-5">
                    {availableOrientations.map(option => (
                      <button
                        key={option}
                        className={`border p-4 rounded text-center w-full lg:w-1/3 flex flex-col lg:flex-row items-center justify-center gap-5 ${selectedOrientation === option ? 'border-pink-500 text-pink-500' : 'border-gray-300 text-gray-700'}`}
                        onClick={() => handleOrientationSelect(option)}
                      >
                        <div className={`mb-4 lg:mb-0 ${getSizeClasses(option)} ${selectedOrientation === option ? 'border-2 border-pink-500' : 'border border-gray-300'}`}></div>
                        {option}
                      </button>
                    ))}
                  </div>
                </div>
              )}
              <div className="mb-4 flex flex-col lg:flex-row justify-between">
                <div className="w-full lg:w-1/2 mr-0 lg:mr-2 mb-4 lg:mb-0">
                  <label className="block text-gray-700 font-bold mb-2">Printed sides</label>
                  <div className="flex items-center border-2 border-pink-500 rounded-xl">
                    <div className="flex-1 relative">
                      <select
                        value={selectedPrintedSides}
                        onChange={(e) => {
                          handlePrintedSidesSelect(e.target.value);
                          setUploadedImageUrl('');
                          setUploadedImageUrl2('');
                          setSelectedImage('first');
                        }}
                        className="block w-full appearance-none text-pink-500 bg-transparent border-none focus:outline-none p-2 pr-8"
                      >
                        <option value="" disabled>Select Printed Sides</option>
                        {printedSides.map((side, index) => (
                          <option key={index} value={side === 'one' ? 'One Side' : 'Two Sides'}>
                            {side === 'one' ? 'One Side' : 'Two Sides'}
                          </option>
                        ))}
                      </select>
                      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-pink-500">
                        <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                          <path d="M7 10l5 5 5-5z" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-full lg:w-1/2 ml-0 lg:ml-2">
                  <label className="block text-gray-700 font-bold mb-2">Lamination</label>
                  <div className="flex items-center border-2 border-pink-500 rounded-xl">
                    <div className="flex-1 relative">
                      <select
                        value={selectedLamination || ""}
                        onChange={(e) => handleLaminationSelect(e.target.value)}
                        className="block w-full appearance-none text-pink-500 bg-transparent border-none focus:outline-none p-2 pr-8"
                      >
                        <option value="" disabled>Select Lamination</option>
                        {laminations.map((lamination, index) => (
                          <option key={index} value={lamination}>
                            {lamination}
                          </option>
                        ))}
                      </select>
                      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-pink-500">
                        <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                          <path d="M7 10l5 5 5-5z" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {Array.isArray(cornerCutStyles) && cornerCutStyles.length > 0 && (
                <div className="mb-4">
                  <label className="block text-gray-700 font-bold mb-4">Corner cut style</label>
                  <div className="flex flex-col lg:flex-row justify-between">
                    {cornerCutStyles.map(option => (
                      <button
                        key={option}
                        className={`border p-4 rounded-xl text-center w-full lg:w-1/2 mx-0 lg:mx-1 flex flex-col lg:flex-row items-center gap-5 ${selectedCornerCutStyle === option ? 'border-pink-500 text-pink-500' : 'border-gray-300 text-gray-700'}`}
                        onClick={() => handleCornerCutStyleSelect(option)}
                      >
                        <div
                          className={`h-16 w-full lg:w-1/2 flex justify-center items-center mt-4 mb-4 lg:mt-0 lg:mb-0 ${selectedCornerCutStyle === option ? 'border-2 border-pink-500' : 'border-2 border-gray-500'} ${option === 'Rounded' ? 'rounded-xl' : ''}`}
                        >
                          <div className={`h-8 w-16 ${option === 'Rounded' ? 'rounded-xl' : ''}`}></div>
                        </div>
                        {option}
                      </button>
                    ))}
                  </div>
                </div>
              )}
              <div className="mb-4 flex flex-col lg:flex-row justify-center">
                <div className="w-full lg:w-1/2 mr-0 lg:mr-2 mb-4 lg:mb-0">
                  <label className="block text-gray-700 font-bold mb-2">White color</label>
                  <p className="text-gray-500 mb-2">Would you require white ink base for your print?</p>
                  <div className="flex justify-start items-center gap-5">
                    {whiteColorOption.includes(0) && (
                      <label className="flex items-center">
                        <input
                          type="radio"
                          name="whiteColor"
                          value="Without white color"
                          checked={selectedWhiteColor === 'Without white color'}
                          onChange={() => handleWhiteColorSelect('Without white color')}
                          className="mr-2"
                        />
                        <span className={selectedWhiteColor === 'Without white color' ? 'text-pink-500' : 'text-gray-700'}>
                          Without white color
                        </span>
                      </label>
                    )}
                    {whiteColorOption.includes(1) && (
                      <label className="flex items-center">
                        <input
                          type="radio"
                          name="whiteColor"
                          value="With white color"
                          checked={selectedWhiteColor === 'With white color'}
                          onChange={() => handleWhiteColorSelect('With white color')}
                          className="mr-2"
                        />
                        <span className={selectedWhiteColor === 'With white color' ? 'text-pink-500' : 'text-gray-700'}>
                          With white color
                        </span>
                      </label>
                    )}
                  </div>
                </div>
                <div className="w-full lg:w-1/2 ml-0 lg:ml-2">
                  <label className="block text-gray-700 font-bold mb-2">Spot UV</label>
                  <p className="text-gray-500 mb-2">Do you require spot UV?</p>
                  <div className="flex justify-start items-center gap-5">
                    {spotUVOptions.includes(1) && (
                      <label className="flex items-center">
                        <input
                          type="radio"
                          name="spotUV"
                          value="Yes"
                          checked={selectedSpotUV === 'Yes'}
                          onChange={() => handleSpotUVSelect('Yes')}
                          className="mr-2"
                        />
                        <span className={selectedSpotUV === 'Yes' ? 'text-pink-500' : 'text-gray-700'}>
                          Yes
                        </span>
                      </label>
                    )}
                    {spotUVOptions.includes(0) && (
                      <label className="flex items-center">
                        <input
                          type="radio"
                          name="spotUV"
                          value="No"
                          checked={selectedSpotUV === 'No'}
                          onChange={() => handleSpotUVSelect('No')}
                          className="mr-2"
                        />
                        <span className={selectedSpotUV === 'No' ? 'text-pink-500' : 'text-gray-700'}>
                          No
                        </span>
                      </label>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-8 mb-8">
              <label className="block text-gray-700 font-bold mb-4">Quantity</label>
              <p className="text-sm text-gray-500 mt-2 mb-5">
                {selectedQuantity && selectedDate !== null ? (
                  `Note: You have selected ${selectedQuantity} items. Your estimated delivery date is ${quantityPrice[0]?.[`date${selectedDate + 1}`]} with a total price of £${quantityPrice.find(item => item.quantity === selectedQuantity)?.[`price${selectedDate + 1}`]}.`
                ) : (
                  "Please select a quantity and receive by date."
                )}
              </p>
              <div className="overflow-x-auto border-collapse border border-pink-500">
                <table className="min-w-full">
                  <thead>
                    <tr>
                      <th className="border p-2">QTY</th>
                      <th className="border p-2">RECEIVE BY<br />{quantityPrice[0]?.date3}</th>
                      <th className="border p-2">RECEIVE BY<br />{quantityPrice[0]?.date2}</th>
                      <th className="border p-2">RECEIVE BY<br />{quantityPrice[0]?.date1}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {quantityPrice.map((item, index) => (
                      <tr key={index} className={`${selectedQuantity === item.quantity ? 'bg-pink-100' : ''}`}>
                        <td
                          className={`border p-2 text-center cursor-pointer ${selectedQuantity === item.quantity ? 'bg-pink-500 text-white' : ''}`}
                          onClick={() => handleQuantitySelect(item.quantity)}
                        >
                          {item.quantity}
                        </td>
                        <td
                          className={`border p-2 text-center cursor-pointer ${selectedQuantity === item.quantity && selectedDate === 2 ? 'bg-pink-500 text-white' : ''}`}
                          onClick={() => handleDateSelect(2)}
                        >
                          £{item.price3}
                        </td>
                        <td
                          className={`border p-2 text-center cursor-pointer ${selectedQuantity === item.quantity && selectedDate === 1 ? 'bg-pink-500 text-white' : ''}`}
                          onClick={() => handleDateSelect(1)}
                        >
                          £{item.price2}
                        </td>
                        <td
                          className={`border p-2 text-center cursor-pointer ${selectedQuantity === item.quantity && selectedDate === 0 ? 'bg-pink-500 text-white' : ''}`}
                          onClick={() => handleDateSelect(0)}
                        >
                          £{item.price1}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="flex flex-col lg:flex-row text-center mt-4 gap-10 mb-10">
              <p className="text-pink-500">
                <strong>Date Time:</strong> Receive by {quantityPrice[0]?.[`date${selectedDate + 1}`]}
              </p>
              {selectedQuantity && quantityPrice.find(item => item.quantity === selectedQuantity) ? (
                <p className="text-pink-500">
                  <strong>Price:</strong> £{quantityPrice.find(item => item.quantity === selectedQuantity)[`price${selectedDate + 1}`]}
                </p>
              ) : (
                <p className="text-pink-500">Please select a quantity and date</p>
              )}
            </div>
            <div className="flex justify-between gap-4 mt-8 mb-8">
              {services.map((service) => (
                <div
                  key={service.id}
                  className={`flex flex-col justify-between p-4 w-full border-2 rounded-lg text-center cursor-pointer ${selectedService === service.name ? 'border-pink-500' : 'border-blue-500'}`}
                  onClick={() => setSelectedService(service.name)}
                >
                  <div className="flex flex-row justify-between mb-4">
                    <span className="text-lg font-semibold">{service.name}</span>
                    <div className="flex justify-center">
                      <input
                        type="radio"
                        checked={selectedService === service.name}
                        onChange={() => setSelectedService(service.name)}
                        className="text-pink-500"
                      />
                    </div>
                  </div>
                  <div className="mb-4 text-gray-500">
                    <p>{service.description}</p>
                    <p className="font-semibold mt-2">Price: £{parseFloat(service.price).toFixed(2)}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 font-bold mb-4">Describe what you're looking for:</label>
              <textarea
                className="mt-1 block w-full border border-gray-300 rounded p-12 focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-transparent"
                rows="4"
              ></textarea>
            </div>
            <p className="text-red-500 font-semibold mb-4">
              Note: To upload two images, please select "Two Sides" from the Printed Sides option.
            </p>
            <div
              {...getRootProps()}
              className="bg-gray-200 border-2 border-gray-300 p-4 text-center rounded shadow mb-8 flex flex-col items-center pt-10 pb-10 w-full"
            >
              <input {...getInputProps()} />
              <img src={image} alt="image" className="w-12 h-12 mb-5" />
              {isDragActive ? (
                <p className="text-black">Drop the files here ...</p>
              ) : (
                !fileUploaded ? (
                  <>
                    <p className="text-black">Drag and Drop Files Here</p>
                    <p className="text-gray-400">or <span className="text-pink-500 cursor-pointer">Browse</span> to choose a file</p>
                  </>
                ) : (
                  <div className="flex flex-col items-center">
                    <p className="text-black">Uploaded file(s): {fileName}</p>
                  </div>
                )
              )}
            </div>
            {fileUploaded && (
              <div className="p-4 text-center mb-8 flex flex-col items-center w-full">
                <button
                  className={`flex items-center text-white px-4 py-2 rounded-full gap-3 ${!selectedSize ? 'cursor-not-allowed opacity-50' : ''}`}
                  style={{ backgroundColor: '#EC008C' }}
                  onClick={() => {
                    if (selectedSize) {
                      setIsProofModalOpen(true);
                    }
                  }}
                  disabled={!selectedSize}
                >
                  Proof check
                </button>
                {!selectedSize && (
                  <p className="text-red-500 text-sm mt-2">
                    Please select a size before proceeding with the proof check.
                  </p>
                )}
              </div>
            )}
            {isProofModalOpen && (
              <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-white rounded-lg shadow-lg w-full h-full lg:h-auto lg:w-3/4 p-4 lg:p-6 relative mx-0 lg:mx-0">
                  <h2 className="text-xl font-bold mb-4">Upload File</h2>
                  <button
                    className="absolute top-4 right-5 text-gray-500 hover:text-black"
                    onClick={() => setIsProofModalOpen(false)}
                  >
                    ✕
                  </button>
                  <div className="flex flex-col lg:flex-row justify-between mb-4 gap-10 overflow-y-auto lg:overflow-visible h-full lg:h-auto ">
                    <div className="w-full pt-14 border border-blue-100 bg-blue-50 relative rounded-lg overflow-auto pt-10 pb-10">
                      <div className="relative flex justify-center items-center overflow-auto pt-20" style={{ maxHeight: '400px', maxWidth: '1000px' }}>
                        <div
                          className="border-8 border-pink-300 rounded-md flex justify-center items-center"
                          style={{
                            width: mmToPx(outerWidth + 3),
                            height: mmToPx(outerHeight + 3),
                            maxWidth: '100%',
                            maxHeight: '100%',
                          }}
                        >
                          <div
                            className="relative border-4 border-yellow-300 rounded-md flex justify-center items-center"
                            style={{
                              width: mmToPx(outerWidth),
                              height: mmToPx(outerHeight),
                              maxWidth: '100%',
                              maxHeight: '100%',
                            }}
                          >
                            <div
                              className="relative border-4 border-blue-500 rounded-md flex justify-center items-center"
                              style={{
                                width: mmToPx(outerWidth - 3),
                                height: mmToPx(outerHeight - 3),
                                zIndex: 10,
                                maxWidth: '100%',
                                maxHeight: '100%',
                              }}
                            >
                              <div className="flex justify-center items-center text-gray-700 font-bold text-xl">
                                {selectedImage === 'first' ? (
                                  <img
                                    src={uploadedImageUrl}
                                    alt="Uploaded File Preview"
                                    style={{
                                      objectFit: 'contain',
                                      width: '100%',
                                      height: '100%',
                                      maxWidth: '100%',
                                      maxHeight: '100%',
                                    }}
                                    className="rounded-md"
                                  />
                                ) : (
                                  <img
                                    src={uploadedImageUrl2}
                                    alt="Uploaded File Preview"
                                    style={{
                                      objectFit: 'contain',
                                      width: '100%',
                                      height: '100%',
                                      maxWidth: '100%',
                                      maxHeight: '100%',
                                    }}
                                    className="rounded-md"
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-full text-gray-600 font-semibold mt-20">
                          <span className="ml-3">{outerWidth || 0}mm</span>
                          <img src={arrow2} alt="Horizontal Arrow" className="w-20 mb-2" />
                        </div>
                        <div className="absolute top-1/2 left-16 transform -translate-y-1/2 -translate-x-full text-gray-600 font-semibold rotate-90">
                          <img src={arrow2} alt="Vertical Arrow" className="w-20" />
                          <span className="ml-3">{outerHeight || 0}mm</span>
                        </div>
                      </div>
                      <div className="flex justify-center items-center gap-5 mt-4">
                        <div
                          className={`border-4 p-1 cursor-pointer ${selectedImage === 'first' ? 'border-pink-500' : 'border-gray-300'}`}
                          onClick={() => setSelectedImage('first')}
                          style={{ width: '100px', height: '100px' }}
                        >
                          <img
                            src={uploadedImageUrl}
                            alt="First Image"
                            style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                            className="rounded-md"
                          />
                        </div>
                        {selectedPrintedSides === 'Two Sides' && uploadedImageUrl2 && (
                          <div
                            className={`border-4 p-1 cursor-pointer ${selectedImage === 'second' ? 'border-pink-500' : 'border-gray-300'}`}
                            onClick={() => setSelectedImage('second')}
                            style={{ width: '100px', height: '100px' }}
                          >
                            <img
                              src={uploadedImageUrl2}
                              alt="Second Image"
                              style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                              className="rounded-md"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="w-full lg:w-1/3 p-4 pb-14 xl:pb-0 border border-gray-200 bg-blue-50 relative rounded-lg overflow-auto">
                      <h3 className="text-gray-900 font-semibold text-lg mb-2">Your Proofs</h3>
                      <div className="p-2 mb-2 bg-white border border-blue-200 rounded-lg">
                        <div className="flex items-center mb-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-4 h-4 text-green-500 mr-2"
                          >
                            <path strokeLinecap="round" strokeLinejoin="round" d="M5 12l4 4L19 7" />
                          </svg>
                          <span className="text-green-500 font-medium">File uploaded</span>
                        </div>
                      </div>
                      <div className="p-2 mb-2 bg-white border border-blue-200 rounded-lg">
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-900 font-semibold">Bleed and safe area</span>
                        </div>
                      </div>
                      <div className="mt-2 mb-4 bg-white p-4 shadow-lg border rounded-lg z-50 w-full">
                        <p className="text-sm font-semibold text-gray-700 mb-2">Selected size: {outerWidth}mm x {outerHeight}mm</p>
                        <div className="p-2 border-l-4 border-red-500 mb-4">
                          <p className="text-sm font-semibold text-gray-900">Bleed Line:</p>
                          <p className="text-xs text-gray-600">This is the outermost edge beyond the trim line where the artwork extends, ensuring no white edges appear after trimming.</p>
                        </div>
                        <div className="p-2 border-l-4 border-yellow-500 mb-4">
                          <p className="text-sm font-semibold text-gray-900">Trim Line:</p>
                          <p className="text-xs text-gray-600">This is the final edge where the printed artwork will be cut to its finished size.</p>
                        </div>
                        <div className="p-2 border-l-4 border-blue-500">
                          <p className="text-sm font-semibold text-gray-900">Safe Area:</p>
                          <p className="text-xs text-gray-600">It is the area inside the trim line where important content, such as text and images, should be placed to avoid being cut off.</p>
                        </div>
                      </div>
                      <p className="text-xs text-gray-500 mb-2">*Please note, a reprint or refund would not be available if you are unsatisfied with your print, as you have chosen to proceed despite the errors.</p>
                      <button className="w-full bg-pink-500 text-white py-2 rounded-full hover:bg-pink-600 mt-5 mb-4" onClick={() => setIsProofModalOpen(false)}>
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
     
      <Products />
      <Sample />
      <Subscribe />
      <FixedImageMessage />
      <Footer />
    </>
  );
};

export default ProductEdits;
